import { Tooltip } from 'antd';
import { CloseOutlined, FullScreen, ExitFullScreen } from '@/sub-luca-plugin/compatible-components/svg-icons';
import { queryDomExample } from '@/sub-luca-plugin/utils/class-example';
import { useGlobalStore } from '@/sub-luca-plugin/store/global';
import classNames from 'classnames';
import './index.scss';
import { tCommon } from '@/sub-luca-plugin/i18n';

interface NavigationHeaderWapperProps {
    className?: string;
    hideBack?: boolean;
    children?: React.ReactNode;
    onClose?: () => void;
}

const NavigationHeaderWapper = ({
    className,
    children, // 接收返回按钮的回调函数
    onClose,
}: NavigationHeaderWapperProps) => {
    const { dragDrawerWidth, setDragDrawerWidthForMin, setDragDrawerWidthForMax, dragDrawerMaxWidth } = useGlobalStore();

    const isFullScreen = dragDrawerWidth >= dragDrawerMaxWidth;

    const handleQaScreenSizeControl = (isFullScreen: boolean) => {
        isFullScreen ? setDragDrawerWidthForMin() : setDragDrawerWidthForMax();
    };

    return (
        <div className={classNames('navigation-bar__header', className)}>
            {children}
            <Tooltip
                title={isFullScreen ? tCommon.t('exitFullScreen', '退出全屏') : tCommon.t('fullScreen', '全屏')}
                placement="bottomRight"
                arrow={{ pointAtCenter: true }}
                getPopupContainer={queryDomExample.queryLucaQaRoot}
                autoAdjustOverflow={false}
            >
                <span className="navigation-bar__qa-screen-size-control" onClick={() => handleQaScreenSizeControl(isFullScreen)}>
                    {isFullScreen ? <ExitFullScreen /> : <FullScreen />}
                </span>
            </Tooltip>
            {onClose && (
                <div className="navigation-bar__close-container" onClick={onClose}>
                    <CloseOutlined className="navigation-bar__close" />
                </div>
            )}
        </div>
    );
};

export default NavigationHeaderWapper;
